'use client';

import { Stepper } from './Stepper';

interface QuantitySelectorProps {
  quantity: number;
  onChange: (quantity: number) => void;
  /** Borne basse (défaut 1 — le tunnel VTC utilise 0 pour les bagages). */
  min?: number;
  max?: number;
  labels: { quantity_label: string; decrease_quantity: string; increase_quantity: string };
  /** Classes additionnelles (ex. bt-quantity--boxed pour l'apparence « input » du tunnel VTC). */
  className?: string;
}

export function QuantitySelector({ quantity, onChange, min = 1, max = 10, labels, className }: QuantitySelectorProps) {
  return (
    <div className={['bt-quantity', className].filter(Boolean).join(' ')}>
      <span className="bt-quantity__label">{labels.quantity_label}</span>
      <Stepper
        value={quantity}
        onChange={onChange}
        min={min}
        max={max}
        labels={{ decrease: labels.decrease_quantity, increase: labels.increase_quantity }}
      />
    </div>
  );
}
